import React from 'react'

import { Branch } from '../types/schema'

interface CityJsonLdProps {
  branches: Branch[]
}

const CityJsonLd: React.FC<CityJsonLdProps> = ({ branches }) => {
  if (!branches?.length) return null

  const social = {
    facebook: 'https://www.facebook.com/Oasisspapage',
    instagram: 'https://www.instagram.com/oasisspathailand/',
    twitter: 'https://twitter.com/the_oasis_spa',
    wechat: 'https://www.weibo.com/oasisthailand',
    line: 'https://lin.ee/1vFOJU5',
    tripadvisor: 'https://goo.gl/Cy4ucd',
    weibo: 'https://www.weibo.com/oasisthailand',
    youtube: 'https://www.youtube.com/user/TheOasisSpa',
    whatsapp: 'https://wa.me/6653920111',
    telegram: 'https://t.me/oasisspabot'
  }

  const jsonLd = branches.map((branch) => ({
    '@context': 'https://schema.org',
    '@type': 'Spa',
    social,
    'name': branch.branch_name2 || branch.name,
    'image': branch.image,
    'url': branch.url,
    'telephone': branch.branch_phone,
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': branch.address,
      'addressLocality': branch.city,
      'addressRegion': branch.area,
      'postalCode': branch.nameandareacity,
      'addressCountry': 'Thailand'
    },
    'geo': {
      '@type': 'GeoCoordinates',
      'latitude': branch.latitude,
      'longitude': branch.longtitude
    },
    'description': branch.long_desc || branch.medium_desc || branch.short_desc,
    'openingHours': `Mon-Sun ${branch.open_timename || '10:00'}-${branch.close_timename || '22:00'}`,
    'amenityFeature': [
      {
        '@type': 'LocationFeatureSpecification',
        'name': 'Free Transportation',
        'value': branch.pickupArea || undefined
      }
    ],
    'isOnlineBooking': true,
    'hasMap': branch.map_link
  }))

  return (
    <script
      type='application/ld+json'
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(jsonLd.length === 1 ? jsonLd[0] : jsonLd)
      }}
    />
  )
}

export default CityJsonLd
